import React from 'react';
import PropTypes from 'prop-types';
import { useSearchContext } from '../../hooks/useSearch';
import {
  Wrapper,
  InputContainer,
  TextInput,
  IconContainer,
  CancelIcon,
  SearchIcon
} from './styled';

const SearchInputHeader = (props) => {
  const { search, setSearch } = useSearchContext();

  return (
    <Wrapper {...props}>
      <InputContainer>
        <TextInput
          type="text"
          placeholder="Search description of cover..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <IconContainer>
          {search?.length > 0 ? (
            <CancelIcon onClick={() => setSearch('')} />
          ) : (
            <SearchIcon />
          )}
        </IconContainer>
      </InputContainer>
    </Wrapper>
  );
};

SearchInputHeader.propTypes = {
  className: PropTypes.string
};

export default SearchInputHeader;
